import axiosInstance from '../config/axios.js';

const API_BASE = '/tanks';

const tankService = {
  // Get all tanks with optional filters and pagination
  getAll: async (page = null, perPage = 10, params = {}) => {
    const queryParams = page !== null
      ? { page, per_page: perPage, ...params }
      : { all: 'true', ...params };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get all tanks without pagination
  getAllTanks: async (params = {}) => {
    const queryParams = {
      all: 'true',
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get tank by ID
  getById: async (tankId) => {
    const response = await axiosInstance.get(`${API_BASE}/${tankId}`);
    return response.data;
  },

  // Get tanks by client ID
  getByClientId: async (clientId) => {
    const response = await axiosInstance.get(`${API_BASE}/client/${clientId}`);
    return response.data;
  },

  // Create new tank
  create: async (tankData) => {
    const response = await axiosInstance.post(API_BASE, tankData);
    return response.data;
  },

  // Update tank
  update: async (tankId, tankData) => {
    const response = await axiosInstance.put(`${API_BASE}/${tankId}`, tankData);
    return response.data;
  },

  // Delete tank
  delete: async (tankId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${tankId}`);
    return response.data;
  }
};

export default tankService;